import { render, staticRenderFns } from "./NewsDetailsFour.vue?vue&type=template&id=9cd01eba&scoped=true"
import script from "./NewsDetailsFour.vue?vue&type=script&lang=js"
export * from "./NewsDetailsFour.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsFour.vue?vue&type=style&index=0&id=9cd01eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd01eba",
  null
  
)

export default component.exports